module.exports = __webpack_public_path__ + "media/images/conference-2-99ee836cce098f30e098e5ef1cb53191.jpg";